import { BillingRunStatus } from "constants/billingRuns";

export const DefaultInitialValues = {
  deploymentId: null,
  exportedAtDateTime: null,
  name: "",
  ruleBookId: null,
  status: BillingRunStatus.DRAFT,
  buyerPaysVendor: false,
};
